document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll('.leftside-item');
  const firstItem = document.querySelector('.leftside-item.first');
  
  
  const img = document.createElement('img');
  img.src = document.getElementById('animalImage')?.getAttribute('src');
  img.style.display = 'block';
  img.style.opacity = 1;

  function isMobile() {
    return window.innerWidth <= 1024;
  }

  if (isMobile()) {
    firstItem?.appendChild(img.cloneNode(true));
  }
      if (items) {
   // document.querySelector('body').addEventListener("scroll",() => {
    window.addEventListener("scroll", () => {
    console.log('works');
    


      items.forEach((item, index) => {
        const itemPosition = item.getBoundingClientRect().top;
        const screenHeight = window.innerHeight;
  
        if (itemPosition <= screenHeight * 0.5) {
          // Додаємо клас active та картинку, якщо її немає
          if (!item.classList.contains('active')) {
            item.classList.add('active');
            // if (isMobile()) {
            //   item.appendChild(img.cloneNode(true));
            // }
          }
          
          // Якщо елемент не перший, видаляємо клас active та картинку з попереднього елемента
          if (index > 0) {
            const previousItem = items[index - 1];
            previousItem.classList.remove('active');
            // const previousImg = previousItem.querySelector('img');
            // if (previousImg) {
            //   previousImg.remove(); // Видаляємо картинку з попереднього елемента
            // }
          }
    
        } else {
          item.classList.remove('active');
          // const imgToRemove = item.querySelector('img');
          // if (imgToRemove) {
          //   imgToRemove.remove(); // Видаляємо картинку, якщо елемент не активний
          // }
        }
      });
    
  });
  }

});


